// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__FiA6S","logoWrapper":"Layout_logoWrapper__WYNVI"};